// extracted by mini-css-extract-plugin
module.exports = {"container":"Dropzone_container__2eDCD"};